import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=39fea53d&scoped=true"
import script from "./side-nav.vue?vue&type=script&lang=js"
export * from "./side-nav.vue?vue&type=script&lang=js"
import style0 from "./side-nav.vue?vue&type=style&index=0&id=39fea53d&lang=scss&scoped=true"
import style1 from "./side-nav.vue?vue&type=style&index=1&id=39fea53d&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fea53d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39fea53d')) {
      api.createRecord('39fea53d', component.options)
    } else {
      api.reload('39fea53d', component.options)
    }
    module.hot.accept("./side-nav.vue?vue&type=template&id=39fea53d&scoped=true", function () {
      api.rerender('39fea53d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/side-nav.vue"
export default component.exports